import runAccessibility from "@/views/menu/runAccessibility";
import { renderWidget } from "@/views/widget/widget"
import { registerKeyboardShortcut } from '@/utils/keyboardShortcut';

import {
    userSettings,
    getSavedUserSettings
} from '@/globals/userSettings';

import { changeLanguage } from "./i18n/changeLanguage";
import { getDefaultLanguage } from "./i18n/getDefaultLanguage";
import { loadLanguages } from "./i18n/Languages";

/**
 * Interface for the accessibility widget return object
 */
export interface AccessibilityWidget {
    changeLanguage: typeof changeLanguage;
}

/**
 * Main accessibility widget initialization function
 * @returns Object with widget methods
 */
export default async function accessibilityWidget(): Promise<AccessibilityWidget> {
    try {
        // Wait for languages to be loaded first
        await loadLanguages();
        
        // Load saved user settings
        const savedSettings = getSavedUserSettings();
        
        // Merge saved settings with current settings
        Object.assign(userSettings, savedSettings);
        
        // Initialize language if not already set
        if (!userSettings.lang) {
            userSettings.lang = getDefaultLanguage();
        }
        
        // Initialize accessibility features
        runAccessibility();

        // Render the widget UI
        renderWidget();
        registerKeyboardShortcut();

        return {
            changeLanguage
        };
    } catch (error) {
        console.error('Failed to initialize accessibility widget:', error);
        
        // Return minimal interface even if initialization fails
        return {
            changeLanguage
        };
    }
}